import React, { useState } from 'react'
import HomePageLayout from 'Pages/Layout/PageLayout'
import { connect } from 'react-redux'
import { RootState } from 'Store'
import { Card, Col, message, Row } from 'antd'
import { ConfirmExport, LoadingView } from 'Components/modal'
import styled from 'styled-components'
import theme from 'Components/common/Theme'
import CsvIcon from '../../assets/img/csv.png'
import { getRequestString, mapWordingReport, toDateQuery } from 'helpers/format'
import { selectCurrentUser } from 'Store/user/selector'
import { ListReq } from 'Store/orders/types'
import { appConfig, themeConfig } from 'config'
import Axios from 'axios'
import downloadCSVFile from 'helpers/export'
import { APIPath } from 'services/APIPath'
import { getStaffPermission } from 'helpers/account'

type Props = {} & ReduxProps

const Reports: React.FunctionComponent<Props> = props => {
  const { currentUser } = props
  const [exportOrderDailog, setExportOrderDailog] = useState(false)
  const [exportFullOrderDailog, setExportFullOrderDailog] = useState(false)
  const [exportMemberDailog, setExportMemberDailog] = useState(false)
  const [exportPurchaseDailog, setExportPurchaseDailog] = useState(false)
  const [exportCustomerDailog, setExportCustomerDailog] = useState(false)
  const [exportStockDailog, setExportStockDailog] = useState(false)
  const [exportStockWithTaxDailog, setExportStockWithTaxDailog] = useState(false)
  const [exporting, setExporting] = useState(false)
  const permission = getStaffPermission()
  const isMock = false

  const onExportOrder = (startDate: string, endDate: string): void => {
    setExporting(true)
    const start = toDateQuery(startDate)
    const end = toDateQuery(endDate)
    const req: ListReq = {
      start_date: start,
      end_date: end,
    }
    const endPoint = appConfig.backofficeEndpoint + `${APIPath.reportOrderFull}?${getRequestString(req)}`
    const header = {
      headers: {
        Authorization: `Bearer ${currentUser.accessToken}`,
        'x-mid': currentUser?.activeMerchant?.id || 0,
        'x-auth-mid': currentUser?.activeMerchant?.id || '',
      },
    }
    Axios.get(endPoint, header)
      .then((res: any) => {
        const reportData = mapWordingReport(res.data)
        const fileName = 'รายงานคำสั่งซื้อทั้งหมด ' + start + 'ถึง' + end
        downloadCSVFile(reportData, fileName)
        setExporting(false)
        setExportOrderDailog(false)
      })
      .catch(error => {
        setExporting(false)
        message.error({
          content: error?.response?.data?.error || 'เกิดข้อผิดพลาด ไม่สามารถ Export ข้อมูลได้',
          key: 'export-error',
        })
      })
  }

  const onExportFullOrder = (startDate: string, endDate: string): void => {
    setExporting(true)
    const start = toDateQuery(startDate)
    const end = toDateQuery(endDate)
    const req: ListReq = {
      start_date: start,
      end_date: end,
    }
    const endPoint =
      appConfig.backofficeEndpoint + `${APIPath.reportOrderProductFull}?${getRequestString(req)}`
    const header = {
      headers: {
        Authorization: `Bearer ${currentUser.accessToken}`,
        'x-mid': currentUser?.activeMerchant?.id || 0,
        'x-auth-mid': currentUser?.activeMerchant?.id || '',
      },
    }
    Axios.get(endPoint, header)
      .then((res: any) => {
        const reportData = mapWordingReport(res.data)
        const fileName = 'รายงานคำสั่งซื้อ(แบบเต็ม) ' + start + 'ถึง' + end
        downloadCSVFile(reportData, fileName)
        setExporting(false)
        setExportOrderDailog(false)
      })
      .catch(error => {
        setExporting(false)
        message.error({
          content: error?.response?.data?.error || 'เกิดข้อผิดพลาด ไม่สามารถ Export ข้อมูลได้',
          key: 'export-error',
        })
      })
  }

  const onExportMember = (startDate: string, endDate: string): void => {
    setExporting(true)
    const start = toDateQuery(startDate)
    const end = toDateQuery(endDate)
    const req: ListReq = {
      start_date: start,
      end_date: end,
    }
    const endPoint = appConfig.backofficeEndpoint + `${APIPath.reportMember}?${getRequestString(req)}`
    const header = {
      headers: {
        Authorization: `Bearer ${currentUser.accessToken}`,
        'x-mid': currentUser?.activeMerchant?.id || 0,
        'x-auth-mid': currentUser?.activeMerchant?.id || '',
      },
    }
    Axios.get(endPoint, header)
      .then((res: any) => {
        const reportData = mapWordingReport(res.data)
        const fileName = 'รายงานข้อมูลสมาชิก ' + start + 'ถึง' + end
        downloadCSVFile(reportData, fileName)
        setExporting(false)
        setExportMemberDailog(false)
      })
      .catch(error => {
        setExporting(false)
        message.error({
          content: error?.response?.data?.error || 'เกิดข้อผิดพลาด ไม่สามารถ Export ข้อมูลได้',
          key: 'export-error',
        })
      })
  }

  const onExportPurchase = (startDate: string, endDate: string): void => {
    setExporting(true)
    const start = toDateQuery(startDate)
    const end = toDateQuery(endDate)
    const req: ListReq = {
      start_date: start,
      end_date: end,
    }
    const endPoint = appConfig.backofficeEndpoint + `${APIPath.reportPurchase}`
    const header = {
      headers: {
        Authorization: `Bearer ${currentUser.accessToken}`,
        'x-mid': currentUser?.activeMerchant?.id || 0,
        'x-auth-mid': currentUser?.activeMerchant?.id || '',
      },
    }
    Axios.post(endPoint, req, header)
      .then((res: any) => {
        const reportData = mapWordingReport(res.data)
        const fileName = 'รายงานข้อมูลระบบจัดซื้อ ' + start + 'ถึง' + end
        downloadCSVFile(reportData, fileName)
        setExporting(false)
        setExportPurchaseDailog(false)
      })
      .catch(error => {
        setExporting(false)
        message.error({
          content: error?.response?.data?.error || 'เกิดข้อผิดพลาด ไม่สามารถ Export ข้อมูลได้',
          key: 'export-error',
        })
      })
  }

  const onExportCustomer = (startDate: string, endDate: string): void => {
    setExporting(true)
    const start = toDateQuery(startDate)
    const end = toDateQuery(endDate)
    const req: ListReq = {
      start_date: start,
      end_date: end,
    }
    const endPoint = appConfig.backofficeEndpoint + `${APIPath.reportCustomerDebt}`
    const header = {
      headers: {
        Authorization: `Bearer ${currentUser.accessToken}`,
        'x-mid': currentUser?.activeMerchant?.id || 0,
        'x-auth-mid': currentUser?.activeMerchant?.id || '',
      },
    }
    Axios.post(endPoint, req, header)
      .then((res: any) => {
        const reportData = mapWordingReport(res.data)
        const fileName = 'รายงานหนีของ คู่ค้า/ลูกค้า ที่เกิดจากระบบขายราคาพิเศษ ' + start + 'ถึง' + end
        downloadCSVFile(reportData, fileName)
        setExporting(false)
        setExportCustomerDailog(false)
      })
      .catch(error => {
        setExporting(false)
        message.error({
          content: error?.response?.data?.error || 'เกิดข้อผิดพลาด ไม่สามารถ Export ข้อมูลได้',
          key: 'export-error',
        })
      })
  }

  const onExportStock = (): void => {
    setExporting(true)
    const req = {
      order_by: 'sum_profit',
      sort: 'desc',
    } as any
    const endPoint = appConfig.backofficeEndpoint + `${APIPath.reportStock}?${getRequestString(req)}`
    const header = {
      headers: {
        Authorization: `Bearer ${currentUser.accessToken}`,
        'x-mid': currentUser?.activeMerchant?.id || 0,
        'x-auth-mid': currentUser?.activeMerchant?.id || '',
      },
    }
    Axios.post(endPoint, req, header)
      .then((res: any) => {
        const reportData = mapWordingReport(res.data)
        const fileName = 'รายงานสินค้าคงเหลือ'
        downloadCSVFile(reportData, fileName)
        setExporting(false)
        setExportStockDailog(false)
      })
      .catch(error => {
        setExporting(false)
        message.error({
          content: error?.response?.data?.error || 'เกิดข้อผิดพลาด ไม่สามารถ Export ข้อมูลได้',
          key: 'export-error',
        })
      })
  }

  const onExportStockWithTax = (): void => {
    setExporting(true)
    const req = {
      order_by: 'sum_profit',
      sort: 'desc',
    } as any
    const endPoint = appConfig.backofficeEndpoint + `${APIPath.reportStockWithTax}?${getRequestString(req)}`
    const header = {
      headers: {
        Authorization: `Bearer ${currentUser.accessToken}`,
        'x-mid': currentUser?.activeMerchant?.id || 0,
        'x-auth-mid': currentUser?.activeMerchant?.id || '',
      },
    }
    Axios.post(endPoint, req, header)
      .then((res: any) => {
        const reportData = mapWordingReport(res.data)
        const fileName = 'รายงานสินค้าคงเหลือ อ้างอิงตามใบกำกับภาษี'
        downloadCSVFile(reportData, fileName)
        setExporting(false)
        setExportStockWithTaxDailog(false)
      })
      .catch(error => {
        setExporting(false)
        message.error({
          content: error?.response?.data?.error || 'เกิดข้อผิดพลาด ไม่สามารถ Export ข้อมูลได้',
          key: 'export-error',
        })
      })
  }

  const ConfirmExportOrderModal = (
    <ConfirmExport
      title="ยืนยันดาวน์โหลดรายงานขาย"
      label="วันที่สั่งซื้อ"
      confirmBtnTxt="ดาวน์โหลด .csv"
      description="หมายเหตุ : สามารถดาวน์โหลดข้อมูลได้สูงสุด 1 เดือน"
      isShow={exportOrderDailog}
      handleOk={onExportOrder}
      handleCancel={() => setExportOrderDailog(false)}
      loading={exporting}
      maxMonth={1}
    />
  )

  const ConfirmExportFullOrderModal = (
    <ConfirmExport
      title="ยืนยันดาวน์โหลดรายงานขาย(แบบเต็ม)"
      label="วันที่สั่งซื้อ"
      confirmBtnTxt="ดาวน์โหลด .csv"
      description="หมายเหตุ : สามารถดาวน์โหลดข้อมูลได้สูงสุด 1 เดือน"
      isShow={exportFullOrderDailog}
      handleOk={onExportFullOrder}
      handleCancel={() => setExportFullOrderDailog(false)}
      loading={exporting}
      maxMonth={1}
    />
  )

  const ConfirmExportMemberModal = (
    <ConfirmExport
      title="ยืนยันดาวน์โหลดรายงานข้อมูลสมาชิก"
      label="วันที่สร้าง"
      confirmBtnTxt="ดาวน์โหลด .csv"
      description="หมายเหตุ : สามารถดาวน์โหลดข้อมูลได้สูงสุด 12 เดือน"
      isShow={exportMemberDailog}
      handleOk={onExportMember}
      handleCancel={() => setExportMemberDailog(false)}
      loading={exporting}
      maxMonth={12}
    />
  )

  const ConfirmExportPurchaseModal = (
    <ConfirmExport
      title="ยืนยันดาวน์โหลดรายงานข้อมูลการจัดซื้อ"
      label="วันที่สั่งซื้อ"
      confirmBtnTxt="ดาวน์โหลด .csv"
      description="หมายเหตุ : สามารถดาวน์โหลดข้อมูลได้สูงสุด 12 เดือน"
      isShow={exportPurchaseDailog}
      handleOk={onExportPurchase}
      handleCancel={() => setExportPurchaseDailog(false)}
      loading={exporting}
      maxMonth={12}
    />
  )

  const ConfirmExportCustomerModal = (
    <ConfirmExport
      title="ยืนยันดาวน์โหลดรายงานข้อมูลหนี้ ของลูกค้า/คู่ค้า"
      label="วันที่สั่งซื้อ"
      confirmBtnTxt="ดาวน์โหลด .csv"
      description="หมายเหตุ : สามารถดาวน์โหลดข้อมูลได้สูงสุด 12 เดือน"
      isShow={exportCustomerDailog}
      handleOk={onExportCustomer}
      handleCancel={() => setExportCustomerDailog(false)}
      loading={exporting}
      maxMonth={12}
    />
  )

  const ConfirmExportStockModal = (
    <ConfirmExport
      title="ยืนยันดาวน์โหลดรายงานสินค้าคงเหลือ"
      label="วันที่"
      confirmBtnTxt="ดาวน์โหลด .csv"
      description="หมายเหตุ : สามารถดาวน์โหลดข้อมูลได้สูงสุด 12 เดือน"
      isShow={exportStockDailog}
      handleOk={onExportStock}
      handleCancel={() => setExportStockDailog(false)}
      loading={exporting}
      maxMonth={12}
    />
  )

  const ConfirmExportStockWithTaxModal = (
    <ConfirmExport
      title="ยืนยันดาวน์โหลดรายงานสินค้าคงเหลืออ้างอิงตามใบกำกับภาษี"
      label="วันที่"
      confirmBtnTxt="ดาวน์โหลด .csv"
      description="หมายเหตุ : สามารถดาวน์โหลดข้อมูลได้สูงสุด 12 เดือน"
      isShow={exportStockWithTaxDailog}
      handleOk={onExportStockWithTax}
      handleCancel={() => setExportStockWithTaxDailog(false)}
      loading={exporting}
      maxMonth={12}
    />
  )

  const renderReportButton = (slug: string, title: string, desc: string, onDownload: () => void) => {
    return isMock || (permission && permission.includes(slug)) ? (
      <Col md={8} xs={24}>
        <MCard loading={false} onClick={onDownload} hoverable>
          <Row align="middle" gutter={[16, 8]}>
            <Col span={6}>
              <Icon src={CsvIcon} />
            </Col>
            <Col span={18}>
              <Title>{title}</Title>
              <Label>{desc}</Label>
            </Col>
          </Row>
        </MCard>
      </Col>
    ) : null
  }

  const onClickExportOrder = () => {
    setExportOrderDailog(true)
  }

  const onClickExportFullOrder = () => {
    setExportFullOrderDailog(true)
  }

  const onClickExportMember = () => {
    setExportMemberDailog(true)
  }

  const onClickExportPurchase = () => {
    setExportPurchaseDailog(true)
  }

  const onClickExportCustomer = () => {
    setExportCustomerDailog(true)
  }

  const onClickExportStock = () => {
    setExportStockDailog(true)
  }

  const onClickExportStockWithTax = () => {
    setExportStockWithTaxDailog(true)
  }

  return (
    <HomePageLayout selected="reports" title="รายงาน">
      <LoadingView isShow={exporting} />
      {ConfirmExportOrderModal}
      {ConfirmExportMemberModal}
      {ConfirmExportFullOrderModal}
      {ConfirmExportPurchaseModal}
      {ConfirmExportCustomerModal}
      {ConfirmExportStockModal}
      {ConfirmExportStockWithTaxModal}
      <Row gutter={[16, 16]} style={{ height: 'max-content' }}>
        {renderReportButton(
          'reports-order-full',
          'รายงานขาย',
          `รายงานขายทั้งหมดในระบบ ประกอบด้วย คำสั่งซื้อผ่านออนไลน์, คำสั่งซื้อผ่าน ${themeConfig.title.terminalName},คำสั่งซื้อผ่านระบบเสนอขายราคาพิเศษ`,
          onClickExportOrder,
        )}
        {renderReportButton(
          'reports-order-product-full',
          'รายงานขาย(แบบเต็ม)',
          'รายงานขายแบบแจกแจงรายละเอียดสินค้ารายคำสั่งซื้อ โดยรวมคำสั่งซื้อจากช่องทางออนไลน์, Terminal และคำสั่งซื้อผ่านระบบเสนอขายราคาพิเศษ',
          onClickExportFullOrder,
        )}
        {renderReportButton(
          'reports-member',
          'รายงานข้อมูลสมาชิก',
          'ข้อมูลสมาชิกที่สมัครสมาชิกผ่านแอป และร้านค้ากรอกข้อมูลผ่านเครื่อง Terminal',
          onClickExportMember,
        )}
        {renderReportButton(
          'reports-purchase',
          'รายงานข้อมูลระบบจัดซื้อ',
          'แสดงรายการข้อมูลการจัดซื้อสินค้าและการรับสินค้าเข้าคลัง ซึ่งประกอบด้วยข้อมูลที่สำคัญ เช่น ชื่อสินค้า จำนวนที่รับเข้าคลัง วันที่รับ กำหนดชำระเงิน ราคาทุน เป็นต้น',
          onClickExportPurchase,
        )}
        {renderReportButton(
          'reports-customer',
          'รายงานหนี้ของลูกค้า/คู่ค้า',
          'แสดงรายการของข้อมูลจากระบบขายราคาพิเศษ ซึ่งประกอบด้วยข้อมูลที่สำคัญ เช่น ชื่อลูกค้า ยอดหนี้ สถานะการชำระเงิน ยอดชำระ ยอดคงค้าง เป็นต้น',
          onClickExportCustomer,
        )}
        {renderReportButton(
          'reports-stock',
          'รายงานสินค้าคงเหลือ',
          'แสดงรายการของข้อมูลสินค้าคงเหลือ โดยสามารถสรุปข้อมูลแต่ละรายการสินค้าที่คงเหลือต้นงวด และ วันสิ้นงวด โดยมีรายละเอียดข้อมูลของสินค้า เช่น ยอดคงเหลือบัญชีสินค้า ณ.วันต้นงวด/สิ้นงวด ต้นทุนขาย ซึ่งสามารถนำไปใช้ในการบันทึกบัญชีสินค้าคงเหลือเมื่อสิ้นงวดต่อไป',
          onExportStock,
        )}
        {renderReportButton(
          'reports-stock-with-tax',
          'รายงานสินค้าคงเหลือ อ้างอิงตามใบกำกับภาษี',
          'แสดงรายการของข้อมูลสินค้าคงเหลือ อ้างอิงตามใบกำกับภาษี',
          onExportStockWithTax,
        )}
      </Row>
    </HomePageLayout>
  )
}

const MCard = styled(Card)`
  text-align: left;
  cursor: pointer;
  border-radius: 10px;
  min-height: 100%;
`

const Title = styled.div`
  font-size: ${theme.typography.h5};
  font-family: ${theme.fontFamily.medium};
  margin-bottom: 5px;
`

const Icon = styled.img`
  width: 60px;
  max-width: 100%;
`

const Label = styled.div`
  font-size: ${theme.typography.body4};
  color: ${theme.colors.grey};
`

const mapStateToProps = (state: RootState) => {
  return {
    currentUser: selectCurrentUser(state),
  }
}

type ReduxProps = ReturnType<typeof mapStateToProps>

export default connect(mapStateToProps)(Reports)
